import { PromotionsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function usePromotionsAPI(): PromotionsApi {
  return new PromotionsApi(apiConfig);
}
